// 使用vuex 获取雾灯信息
import axios from "axios"

export default {
	namespaced:true,
	actions:{
		getLEDHostListData(context){
			axios.get('http://47.111.99.118:8089/system/HostList').then(
                response => {
                    console.log('请求成功了',response.data)
                    context.ledHostList = response.data.data;
					// context.commit('GETLEDHOSTLISTDATA',response.data.data);
                    for(let i=0 ; i <context.ledHostList.length ;i++){
						let pos = {lng: context.ledHostList[i].lon , lat: context.ledHostList[i].lat};
							
					}
                    console.log('context.ledHostList = ',context.ledHostList[0].lon);
                },
                error => {
                    console.log('请求失败了',error.message)
                }
            )
		},
	},
	mutations:{
		BD09TOWGS84(state ,pos){
	
		}
	},
	state:{
		ledHostList:[], 
		positions:[],
	},
	getters:{
		ledHostListData(state){
			return state.ledHostList ;
		},
		ledHostListPos(state){
			return state.positions ;
		}
	},
}